<template>
  <div class="pegawai">
    <div class="divider mobile-small-hide"></div>
    <div class="divider mobile-small-hide"></div>
    <b-container v-if="facility">
      <b-row>
        <b-col md="4" lg="3" xl="3">
          <a href="#" class="profile-card profile-card--alone">
            <div class="profile-card__image">
              <div
                class="inner"
                :style="{ backgroundImage: 'url(\'' + facility.image + '\')' }"
              >
                <h3>{{ facility.name }}</h3>
              </div>
            </div>
            <div class="profile-card__content">
              <h1>{{ facility.name }}</h1>
              <!-- <h2>{{ employee.npp }}</h2> -->
            </div>
          </a>
        </b-col>
        <b-col cols="1" class="tablet-small-hide">&nbsp;</b-col>
        <b-col sm="8" md="8" lg="8" xl="8">
          <div class="text-title">
            <p id="rating-id" style="display: none">{{ facility.id }}</p>
            <h2 id="rating-name">{{ facility.name }}</h2>
            <!-- <input type="hidden" id="rating-percentage" :value="facility.percentage"/> -->
            <p>Berikan penilaian terhadap {{ facility.name }}</p>
          </div>
          <div class="divider divider--margin-small mobile-small-show"></div>
          <div class="divider mobile-small-hide"></div>

          <div class="rate-animation">
            <ul class="rate-animation__list">
              <li>
                <svg class="icon"><use xlink:href="#icon-star-full"></use></svg>
              </li>
              <li>
                <svg class="icon"><use xlink:href="#icon-star-full"></use></svg>
              </li>
              <li>
                <svg class="icon"><use xlink:href="#icon-star-full"></use></svg>
              </li>
              <li>
                <svg class="icon"><use xlink:href="#icon-star-full"></use></svg>
              </li>
              <li>
                <svg class="icon"><use xlink:href="#icon-star-full"></use></svg>
              </li>
            </ul>
            <rate
              :length="5"
              @after-rate="onAfterRate"
              v-model="vrating.rating.rate"
            />
          </div>

          <div class="penilaian-text" v-if="showSuggestion">
            <div class="divider"></div>
            <div class="divider mobile-small-hide"></div>
            <div class="text-title">
              <p v-if="vrating.rating.rate <= 3">
                <strong>Penilaian apa yang harus diperbaiki?</strong>
              </p>
              <p v-else><strong>Penilaian apa yang sudah baik?</strong></p>
              <div class="divider divider--margin-small"></div>
              <div class="cst-checkbox">
                <b-form-checkbox-group
                  v-model="vrating.rating.suggestions"
                  :options="facility.suggestions"
                  name="checkboxPenilaian"
                  buttons
                  button-variant="outline-primary"
                  @focus="show"
                  data-layout="normal"
                ></b-form-checkbox-group>
              </div>
            </div>
            <div class="mobile-small-show">
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
              <div class="divider"></div>
            </div>
          </div>

          <div class="divider"></div>
          <div class="divider mobile-small-hide"></div>

          <div class="btn-layout-float">
            <b-row align-v="center">
              <b-col md="3" lg="3" xl="4">
                <!-- <p class="no-margin">Penilaian {{ index+1 }} dari {{ aspects.length }}</p>
                            <div class="divider divider--margin-small mobile-small-show"></div> -->
              </b-col>
              <b-col
                md="9"
                lg="9"
                xl="8"
                class="
                  text-right-2
                  mobile-small-text-left
                  btn-mobile-row-bottom
                "
              >
                <b-button
                  @click.prevent="$router.go(-1)"
                  variant="outline-primary"
                  class="cst-button"
                >
                  <div
                    class="
                      cst-button__wrapper
                      cst-button__icon
                      cst-button__icon--left
                    "
                  >
                    <img src="../assets/Left@2x.png" alt="" /> Kembali
                  </div>
                </b-button>
                &nbsp;
                <b-button
                  :disabled="
                    vrating.rating.rate <= facility.min_star &&
                    (!vrating.rating.suggestions ||
                      vrating.rating.suggestions.length == 0)
                  "
                  @click="showConfirmModal"
                  variant="warning"
                  class="cst-button"
                >
                  <div class="cst-button__wrapper cst-button__icon">
                    Simpan <img src="../assets/Right@2x.png" alt="" />
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <vue-touch-keyboard
      id="keyboard"
      :options="options"
      v-if="visible"
      :layout="layout"
      :cancel="hide"
      :accept="accept"
      :input="input"
    />

    <b-modal ref="confirmModal" hide-header hide-footer>
      <div class="d-block text-center">
        <div class="text-title text-title--sub">
          <h2>Simpan Penilaian</h2>
          <p>Apakah Anda sudah yakin dengan penilaian anda?</p>
        </div>
      </div>
      <div class="divider"></div>
      <b-row>
        <b-col>
          <b-button
            @click="hideConfirmModal"
            block
            variant="outline-primary"
            class="cst-button"
          >
            <div class="cst-button__wrapper">Tidak</div>
          </b-button>
        </b-col>
        <b-col>
          <b-button
            v-if="visitor"
            @click="simpanPenilaian()"
            block
            variant="warning"
            class="cst-button"
          >
            <div class="cst-button__wrapper">Simpan</div>
          </b-button>
          <b-button
            v-else
            @click="showBioModal"
            block
            variant="warning"
            class="cst-button"
          >
            <div class="cst-button__wrapper">Ya</div>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="bioModal" hide-header hide-footer>
      <div class="d-block text-center">
        <div class="text-title text-title--sub">
          <h2>Kepuasan Anda, Komitmen Kami</h2>
          <p>Silahkan masukkan data diri Anda.</p>
        </div>
      </div>
      <div class="divider"></div>
      <div>
        <b-form-input
          v-model="visitorData.name"
          placeholder="Nama"
          class="cst-input"
          @focus="show"
          data-layout="compact"
        ></b-form-input>
        <div class="divider divider--margin-small"></div>
        <b-form-input
          v-model="visitorData.phone"
          placeholder="Nomor Handphone"
          class="cst-input"
          @focus="show"
          v-validate="{ required: true, regex: /^08?\d+$/ }"
          @input="checkRegexPhone"
          ref="inputPhone"
          data-layout="numeric"
        ></b-form-input>
        <small style="color: red" for="" v-show="visitorError != ''">{{
          visitorError
        }}</small>
      </div>
      <div class="divider"></div>
      <b-row>
        <b-col>
          <b-button
            @click="hideBioModal"
            block
            variant="outline-primary"
            class="cst-button"
          >
            <div class="cst-button__wrapper">Batal</div>
          </b-button>
        </b-col>
        <b-col>
          <b-button
            @click="checkVisitor()"
            :disabled="!visitorData.name || !visitorData.phone"
            block
            variant="warning"
            class="cst-button"
            id="simpanBtn"
          >
            <div class="cst-button__wrapper" id="isiSimpanBtn">Simpan</div>
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import api from "@/api/facilities";
import visitors from "@/api/visitors";
import storage from "@/storage";
export default {
  name: "penilaiandetailfasilitas",
  data() {
    return {
      visible: false,
      layout: "normal",
      input: null,
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      facility: null,
      disabledBtn: true,
      showSuggestion: false,
      savedData: null,
      vrating: {
        is_facility: 1,
        facility_id: this.$route.params.fid,
        notes: "",
        rating: {
          aspect_name: null,
          aspect_id: this.$route.params.fid,
          aspect_image: null,
          rate: null,
          suggestions: null,
        },
      },
      visitor: null,
      visitorData: {
        phone: null,
        name: null,
      },
    };
  },
  mounted() {
    this.getFacility();
    this.visitor = storage.getVisitor();
  },
  methods: {
    checkData() {
      this.savedData = storage.get();
      if (this.savedData) {
        this.savedData.forEach((element) => {
          if (
            element.is_facility &&
            element.facility_id == this.$route.params.fid
          ) {
            this.vrating = element;
            this.vrating.rating.suggestions = this.vrating.rating.suggestions
              ? JSON.parse(element.rating.suggestions)
              : null;
            if (this.vrating.rating.rate <= this.facility.min_star) {
              this.showSuggestion = true;
            }
          }
        });
      }
    },
    getFacility() {
      var self = this;
      this.loadingText = "Loading...";
      api
        .getFacility(this.$route.params.fid)
        .then(function (response) {
          // handle success
          self.hasResult = true;
          self.facility = response.data.data;
          console.log(self.facility);
          self.vrating.rating.aspect_name = self.facility.name;
          self.vrating.rating.aspect_image = self.facility.image;
          self.checkData();
        })
        .catch(function (error) {
          console.log(error);
          self.loadingText = "Outlet tidak ditemukan";
          self.hasResult = false;
          self.facility = null;
        });
    },
    // getData() {
    //     console.log(storage.get());
    // },
    saveData(data) {
      console.log(data);
      storage.saveData(data);
    },
    simpanPenilaian() {
      var data = this.vrating;
      data.rating.suggestions = data.rating.suggestions
        ? JSON.stringify(data.rating.suggestions)
        : null;
      data.rating.type = "STAR";
      data.rating = [data.rating];
      this.saveData(data);
      this.hideConfirmModal();
      this.$router.push("/home/" + this.$route.params.outlet);
    },
    checkVisitor() {
      var self = this;
      var params = {
        phone: this.visitorData.phone,
        name: this.visitorData.name,
        outlet_code: this.$route.params.outlet,
      };
      visitors
        .check(params)
        .then(function (response) {
          // handle success
          console.log(response.data.data);
          storage.saveVisitor({
            phone: params.phone,
            name: params.name,
            outlet_code: params.outlet_code,
            sessionCode: response.data.data.sessionCode,
          });
          self.hideBioModal();
          self.simpanPenilaian();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onAfterRate(rate) {
      let star1 = document.querySelector(
        ".rate-animation__list li:nth-child(1)"
      );
      let star2 = document.querySelector(
        ".rate-animation__list li:nth-child(2)"
      );
      let star3 = document.querySelector(
        ".rate-animation__list li:nth-child(3)"
      );
      let star4 = document.querySelector(
        ".rate-animation__list li:nth-child(4)"
      );
      let star5 = document.querySelector(
        ".rate-animation__list li:nth-child(5)"
      );

      if (rate == 1) {
        star1.classList.add("animation");
        setTimeout(function () {
          star1.classList.remove("animation");
        }, 1000);
      } else star1.classList.remove("animation");

      if (rate == 2) {
        star2.classList.add("animation");
        setTimeout(function () {
          star2.classList.remove("animation");
        }, 1000);
      } else star2.classList.remove("animation");

      if (rate == 3) {
        star3.classList.add("animation");
        setTimeout(function () {
          star3.classList.remove("animation");
        }, 1000);
      } else star3.classList.remove("animation");

      if (rate == 4) {
        star4.classList.add("animation");
        setTimeout(function () {
          star4.classList.remove("animation");
        }, 1000);
      } else star4.classList.remove("animation");

      if (rate == 5) {
        star5.classList.add("animation");
        setTimeout(function () {
          star5.classList.remove("animation");
        }, 1000);
      } else star5.classList.remove("animation");

      if (rate <= this.facility.min_star) {
        this.showSuggestion = true;
      } else {
        this.vrating.rating.suggestions = null;
        this.showSuggestion = false;
        this.disabledBtn = false;
      }
    },
    showConfirmModal() {
      this.$refs["confirmModal"].show();
    },
    hideConfirmModal() {
      this.$refs["confirmModal"].hide();
    },
    showBioModal() {
      this.$refs["bioModal"].show();
      this.$refs["confirmModal"].hide();
    },
    hideBioModal() {
      this.$refs["bioModal"].hide();
      // this.vrating.rate = this.vrating[this.vrating.length - 1].rate*20
      // this.vrating.rate_times_percentage = this.vrating[this.vrating.length - 1].rate_times_percentage*20
      // this.vrating.notes = this.vrating[this.vrating.length - 1].notes
      // this.srating = this.vrating[this.vrating.length - 1].suggestions
      // this.vrating.splice(this.vrating.length-1, this.vrating.length)
    },
    accept() {
      this.hide();
    },
    show(e) {
      this.input = e.target;
      this.layout = e.target.dataset.layout;

      if (!this.visible)
        if (
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.visible = true;
        }
    },
    hide() {
      this.visible = false;
    },
    checkRegexPhone() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          if (this.visitorData.phone.slice(0) == "0") {
            this.$refs.inputPhone.$el.classList.remove("is-invalid");
          } else {
            this.visitorData.phone = "";
            this.$refs.inputPhone.$el.classList.add("is-invalid");
            return;
          }
        } else {
          if (this.visitorData.phone.length >= 14) {
            console.log(this.visitorData.phone.replace(/.$/, ""));
            this.visitorData.phone = this.visitorData.phone.replace(/.$/, "");
            this.$refs.inputPhone.$el.classList.add("is-invalid");
            return;
          }

          if (
            this.visitorData.phone.length == 2 &&
            this.visitorData.phone.slice(1) != "8"
          ) {
            this.visitorData.phone = "";
            this.$refs.inputPhone.$el.classList.add("is-invalid");
            return;
          }
          this.$refs.inputPhone.$el.classList.remove("is-invalid");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
button:focus {
  outline: 0 !important;
  box-shadow: none !important;
}
</style>
